<template>
  <!-- 城市弹框「点外面关闭」的判定统一放在 document 监听里（见 onDocumentClick）：
       已选过城市 → 点弹框外面可关闭；还没选过城市 → 拦住，必须选一个 -->
  <div class="header">
    <!-- 城市弹框打开时的遮罩层：层级低于下拉面板（.ivu-select-dropdown 是 z-index:900），
         高于页面与头部内容。点遮罩等同「点弹框外面」，仍由 onDocumentClick 按
         「是否已选过城市」决定关不关（见文件顶部注释） -->
    <div v-if="cityPanelOpen" class="cityMask"></div>
    <div class="MenuBox">
      <HeaderMenu class="HeaderMenu" :configData="config" :alone="this.alone" />
    </div>
    <div
      class="notice"
      v-if="
        config.home_notice_marquee && config.home_notice_marquee.switch == 1
      "
    >
      <div class="notice-content">
        <Notice :noticeData="config.home_notice_marquee"></Notice>
      </div>
    </div>
    <div class="header-content b lr ac pb">
      <div class="b ac">
        <img
          class="header-logo"
          @click="backHome()"
          :src="config.logo + '?time=' + date"
          alt="logo"
        />
        <div class="headRight">
          <p class="tag">{{ this.logo_slogan }}</p>
          <Dropdown
            trigger="custom"
            :visible="visible"
            class="choseCity"
            placement="bottom-start"
            :class="showCityList ? 'showCityList' : ''"
          >
            <a href="javascript:void(0)" @click.stop="handleOpen">
              {{ currentCity.nm || '请选择' }}
              <Icon type="ios-arrow-down"></Icon>
            </a>
            <DropdownMenu slot="list">
              <DropdownItem>
                <!-- .stop：面板内部的点击（字母分组、城市按钮等）不冒泡到 document，
                     避免被「点外面」的逻辑误判；Dropdown 的列表可能被 transfer 到 body，
                     所以拦在 City 的根节点上最稳 -->
                <City @on-choosed="whenCityChoosed" @click.native.stop />
              </DropdownItem>
            </DropdownMenu>
          </Dropdown>
        </div>
      </div>
      <div class="search-wrap b lr ac" v-if="showSearch">
        <Input
          class="search-input"
          search
          v-model="searchWords"
          enter-button
          placeholder="输入关键词搜索"
          @on-search="onSearch"
        />
      </div>
    </div>
    <div class="channelBox b" v-if="switch_show">
      <div class="content">
        <switch-channel></switch-channel>
      </div>
    </div>
  </div>
</template>

<script>
import qs from 'qs';
import { mapState } from 'vuex';
import { geo, getSiteConfig } from '@/service/common';
import { consentPrivacy } from '@/service/index';
import { logger, setTitle, setIcon, showConfirm, showToast } from '@/common';
import { getAllCity } from '@/service/common';
import { tryCatch } from '@/utils';
import HeaderMenu from './HeaderMenu';
import Notice from './Notice';
import City from '@/components/city/City';
import SwitchChannel from '@/components/layout/SwitchChannel.vue';
import defalutLogo from '@/assets/images/common/panda_logo.png';
import localStorage from '@/utils/storage/localStorage';
import sessionStorage from '@/utils/storage/sessionStorage';
import { getChannelId, jump, jump2 } from '@/common';
import { elementClick } from '@/utils/track/baidu_statistics';
import { showSwitchPath } from '@/config';

export default {
  name: 'appHeader',
  data() {
    return {
      defalutLogo, //默认的logo
      searchWords: '',
      switch_show: false,
      pathArr: showSwitchPath,
      showSearch: true,
      configData: '',
      logo_slogan: '',
      alone: false,
      showCityList: false,
      // 「请先选择城市」提示只弹一次（每次打开弹框重置，避免点外面反复弹）
      cityTipShown: false,
      // 定位流程是否已给出结论（已写入城市 / 已弹过「定位失败」提示）。
      // 页面请求失败会把 currentCity 置成 { id: -1 }，据此决定要不要抢先展开城市浮层：
      // 没结论时不抢，避免城市浮层被随后的「定位失败」提示盖住、两个提示叠在一起
      cityGuideSettled: false,
      // 定位流程迟迟不出结论时的兜底计时器
      cityGuideTimer: null,
      date: new Date().getTime(),
      visible: false
    };
  },
  mounted() {
    this.loadCommonConfig();
    this.loadCities();
    this.checkPath();
    this.setAlone();
    // 点弹框外面关不关，统一在这里判断（见 onDocumentClick）
    document.addEventListener('click', this.onDocumentClick);
  },
  beforeDestroy() {
    document.removeEventListener('click', this.onDocumentClick);
  },
  methods: {
    // 打开城市弹框：visible 是 Dropdown 的展开态，showCityList 让列表强制 display:block
    openCityPanel() {
      this.visible = true;
      this.showCityList = true;
      this.cityTipShown = false;
    },
    closeCityPanel() {
      this.handleClose();
      this.hideCityList();
    },
    // 点城市名：已展开且已选过城市才允许收起；还没选过城市则保持展开并提示
    handleOpen() {
      if (this.cityPanelOpen) {
        if (!this.hasChoosedCity) return this.warnChooseCity();
        return this.closeCityPanel();
      }
      this.openCityPanel();
    },
    handleClose() {
      this.visible = false;
    },
    // 还没选过城市时的提示：每次打开弹框只提示一次，避免点外面反复弹
    warnChooseCity() {
      if (this.cityTipShown) return;
      this.cityTipShown = true;
      showToast(
        {
          message: '请先选择城市'
        },
        'warning'
      );
    },
    /**
     * 点击城市弹框以外的地方：
     * - 已经选过城市 → 关闭弹框（这是本次要优化的交互）
     * - 还没选过城市 → 拦住不关，必须选一个（视觉上表现为「点外面关不掉」）
     * 弹框内部与城市名（触发器）上的点击都带了 .stop，不会走到这里。
     */
    onDocumentClick() {
      if (!this.cityPanelOpen) return;
      if (!this.hasChoosedCity) return this.warnChooseCity();
      this.closeCityPanel();
    },
    whenCityChoosed(cityInfo = {}) {
      const { amap, ...rest } = cityInfo;
      let chooseLocation = rest;
      if (amap) {
        const { location } = amap;
        if (location) {
          const lng = +location.split(',')[0];
          const lat = +location.split(',')[1];
          sessionStorage.set('lng', lng);
          sessionStorage.set('lat', lat);
          chooseLocation.lng = lng;
          chooseLocation.lat = lat;
        }
      }
      localStorage.set('lastLocationCityInfo', chooseLocation);
      sessionStorage.set('current_city', cityInfo);
      this.$store.commit('common/setCurrentCityInfo', chooseLocation);
      this.hideCityList();
      this.visible = false;
      window.location.reload();
    },
    onSearch() {
      // 为空时，生日专区需要
      let path = this.$route.path;
      let query = this.$route.query;
      if (
        !this.searchWords &&
        !(
          path.includes('birthday') ||
          path.includes('/mall/list') ||
          path.includes('live_service') ||
          path.includes('life_privilege')
        )
      )
        return;
      // 区分各专场的搜索
      if (
        path.includes('mall') ||
        path.includes('birthday') ||
        path.includes('live_service') ||
        path.includes('life_privilege')
      ) {
        let url = '/mall/list?';
        if (path.includes('birthday')) {
          url = '/birthday/list?';
          query.channel_id = 13;
        } else if (path.includes('life_privilege')) {
          url = '/life_privilege/list?';
          query.channel_id = 59;
        } else if (path.includes('live_service')) {
          url = '/live_service/list?';
          query.channel_id = 34;
        }
        // 商城搜索
        if (this.searchWords == undefined) this.searchWords = '';
        if (this.searchWords.length == 0 && !query.keyword) return;
        let req = '';
        let flag = true;
        for (let i = 0; i < Object.keys(query).length; i++) {
          let item = Object.keys(query)[i];
          if (item == 'keyword') {
            flag = false;
            if (this.searchWords.length == 0) {
              continue;
            }
            query[item] = this.searchWords;
          }
          // 值可能来自 URL / 搜索框，拼串前必须编码，否则可注入额外参数
          req += `${item}=${encodeURIComponent(query[item])}&`;
        }
        if (flag && this.searchWords.length != 0)
          req += `keyword=${encodeURIComponent(this.searchWords)}&`;
        req = req.substring(0, req.length - 1);
        jump2(`${url}${req}`);
      } else if (path.includes('movie')) {
        // 电影搜索（关键词来自搜索框，必须编码）
        jump(
          `/movie/cinema_searchResult?keyword=${encodeURIComponent(
            this.searchWords
          )}`
        );
      } else if (path.includes('tour')) {
        // 景点搜索（关键词来自搜索框，必须编码）
        jump(
          `/tour/searchResult?keyword=${encodeURIComponent(this.searchWords)}`
        );
      } else {
        // 其它专场页（如兑换专区 /exchange、礼包页）：原逻辑没有分支，
        // 搜索框输入后点击无任何反应，这里统一按当前渠道进商城搜索
        if (!this.searchWords) return;
        jump2(
          `/mall/list?channel_id=${getChannelId()}&keyword=${encodeURIComponent(
            this.searchWords
          )}`
        );
      }
      // else if (path.includes('birthday')) {
      //   let channelId = '';
      //   let keyword = '';
      //   if (path == '/birthday/list') {
      //     channelId = 'channel_id=13&';
      //   }
      //   if (this.searchWords) {
      //     keyword = 'keyword=' + this.searchWords;
      //   }
      //   jump(`/birthday/list?${channelId}${keyword}`);
      // }
      elementClick('搜索', this.searchWords);
    },
    handleWhenLocationFail(cities) {
      this.cityList = cities;
      if (this.$route.path == '/login') {
        //登录页检测定位失败不弹窗
        return false;
      }
      // 定位已有结论：之后 currentCity 再变成 -1 就不再抢先展开浮层
      this.cityGuideSettled = true;
      showConfirm({
        title: '温馨提示',
        // Modal.confirm 的按钮文案字段是 okText（原来写的 onText 不生效，按钮显示成默认的「确定」）
        okText: '去选择城市',
        // 必须先选城市，取消等于让用户卡在不可用的页面，只留一个确定按钮
        showCancel: false,
        content: `系统检测定位失败，不选择城市部分服务将不可用，请手动选择您所在的城市`
        // content: `系统检测定位失败，是否为您切换至默认城市「${defaultCity.nm}」，不选择城市部分服务将不可用，稍后您也可手动选择对应城市`
      })
        .then(() => {
          // 定位失败：强制展开城市弹框（visible 与 showCityList 一起置位，
          // 保证展开态判定（cityPanelOpen）一致）
          this.openCityPanel();
        })
        .catch(() => {
          // 弹窗被右上角关掉时也要能选城市（showConfirm 的 reject 不接会抛未处理异常）
          this.openCityPanel();
        });
    },
    // 通过城市名取中心坐标。
    // 高德拿不到（跨域/超时/配额）时不再整页刷新 —— 直接按「无坐标」保存城市，
    // 与 h5 city.vue 的处理一致（失败只记日志，城市照常选中）
    getCityPos(city = {}) {
      return geo({
        address: city.nm
      })
        .then(amap => {
          // 保存定位信息
          this.whenCityChoosed({ ...city, amap });
        })
        .catch(err => {
          logger({ message: '通过城市名称获取位置信息失败', error: err });
          this.whenCityChoosed(city);
        });
    },
    async loadCities() {
      const lastLocationCityInfo = localStorage.get('lastLocationCityInfo');
      if (lastLocationCityInfo) {
        const locationInfo = localStorage.get('lastLocationCityInfo');
        sessionStorage.set('current_city', locationInfo);
        this.$store.commit('common/setCurrentCityInfo', lastLocationCityInfo);
        // this.loadCommonConfig(locationInfo.id);
        // 已有缓存城市，定位流程不会再跑：标记为「已给出结论」
        this.cityGuideSettled = true;
        return;
      }
      let cities = sessionStorage.get('cities');
      if (!cities || !cities.length) {
        cities = await getAllCity();
        sessionStorage.set('cities', cities);
      }
      this.hotCities = cities.filter(item => +item.is_hot === 1);
      tryCatch(
        async () => {
          const autoLoc = await this.startLocation().catch(e => e);
          const addressComponent = autoLoc.addressComponent || {};
          const autoLocCity = addressComponent.city;
          const pos = autoLoc.position;
          if (/failed/gi.test(autoLoc.message)) {
            this.handleWhenLocationFail(cities);
          } else {
            let matchedCity;
            cities.forEach(city => {
              if (new RegExp(city.nm, 'ig').test(autoLocCity)) {
                matchedCity = city;
              }
            });
            if (!matchedCity) {
              logger('未匹配到城市');
              this.handleWhenLocationFail(cities);
            } else {
              // this.saveLocationInfo(matchedCity);
              sessionStorage.set('lat', pos.latitude);
              sessionStorage.set('lng', pos.longitude);
              const locationInfo = {
                lat: pos.latitude,
                lng: pos.longitude,
                ...matchedCity
              };
              localStorage.set('lastLocationCityInfo', locationInfo);
              sessionStorage.set('current_city', locationInfo);
              this.$store.commit('common/setCurrentCityInfo', locationInfo);
              this.cityGuideSettled = true;
              this.loadCommonConfig(locationInfo.id);
            }
          }
        },
        () => {
          const locationInfo = localStorage.get('lastLocationCityInfo');
          sessionStorage.set('current_city', locationInfo);
          this.$store.commit('common/setCurrentCityInfo', locationInfo);
          this.loadCommonConfig(locationInfo.id);
        }
      );
    },
    // 加载全局配置
    loadCommonConfig(cityId) {
      let { channel_id, custom_id } =
        qs.parse(location.search.replace('?', '')) || {};
      if (!channel_id) {
        channel_id = sessionStorage.get('channel_id');
      }
      getSiteConfig(channel_id, custom_id, cityId)
        .then(res => {
          if (res.site_gray) {
            document.documentElement.style.filter = 'grayscale(100%)';
          }
          this.logo_slogan = res.logo_slogan;
          this.$store.commit('common/setConfig', res);
          this.configData = res;
          // res.theme_color = 'green';
          if (res.theme_color && res.theme_color.indexOf('#') == -1) {
            this.setTheme(res.theme_color);
          }
          setTitle(res.title);
          setIcon(res.icon);

          let session_info = localStorage.get('session_info');

          if (session_info && session_info.token) {
            if (res.consent_privacy === 0) {
              // 请求
              consentPrivacy().then(() => {});
            }
          }
        })
        .catch(err => {
          logger(err);
        });
      this.setSessionIntoToVuex();
    },
    setSessionIntoToVuex() {
      const sessionInfo = localStorage.get('session_info');
      this.$store.commit('common/setSessionInfo', sessionInfo);
    },
    getDefaultCity(cities) {
      let defaultCity;
      cities.forEach(city => {
        if (+city.is_default === 1) {
          defaultCity = city;
        }
      });
      return defaultCity;
    },
    startLocation() {
      return new Promise((resolve, reject) => {
        const AMap = window.AMap;
        // 高德脚本没加载出来时直接 reject：原来 `return` 会让 Promise 永远 pending，
        // 定位流程卡死 → 既不写城市也不弹「定位失败」提示，用户对着不可用的页面无从下手
        if (!AMap) return reject(new Error('AMap 未加载'));
        AMap.plugin('AMap.Geolocation', function() {
          const geolocation = new AMap.Geolocation({
            // 是否使用高精度定位，默认：true
            enableHighAccuracy: true,
            // 设置定位超时时间，默认：无穷大
            timeout: 10000
          });
          geolocation.getCurrentPosition();
          AMap.event.addListener(geolocation, 'complete', onComplete);
          AMap.event.addListener(geolocation, 'error', onError);
          function onComplete(data) {
            resolve(data);
          }
          function onError(err) {
            reject(err);
          }
        });
      });
    },
    checkPath() {
      this.switch_show = false;
      this.switch_show = this.pathArr.some(item => {
        return item == window.location.pathname;
      });
      this.showSearch = true;
      if (this.$route.meta.isCommon) {
        this.showSearch = false;
      }
    },
    setTheme(theme) {
      if (!theme) return;
      // 设置皮肤
      // blue-green-orange
      let ele = window.document.documentElement;
      // 第一个参数： mixin中我们自定义声明的名称-第二个参数：颜色
      ele.setAttribute('fontColor-theme', theme);
      ele.setAttribute('background-theme', theme);
      ele.setAttribute('border-theme', theme);
      ele.setAttribute('id', theme);
      require(`@/style/skin/${theme}.scss`);
    },
    backHome() {
      if (window.location.pathname == '/infoGathering') {
        return false;
      }
      let custom_id =
        this.$route.query.custom_id || sessionStorage.get('custom_id');
      if (+custom_id == 362) {
        return (window.location.href = '/home?custom_id=362');
      }
      if (+custom_id == 806) {
        return (window.location.href =
          '/partition?mode=exchange&channel_id=2137&custom_id=806');
      }
      if (this.alone) {
        let channel_id = sessionStorage.get('channel_id');
        window.location.href = `/customization?channel_id=${channel_id}`;
      } else {
        window.location.href = `/mall?channel_id=10&custom_id=${this.customId}`;
      }
    },
    setAlone() {
      if (this.alone_custom) {
        this.alone = true;
        this.showSearch = false;
      }
    },
    hideCityList() {
      this.showCityList = false;
    }
  },
  components: {
    City,
    HeaderMenu,
    Notice,
    SwitchChannel
  },
  computed: {
    ...mapState('common', [
      'config',
      'currentCity',
      'channelId',
      'customId',
      'alone_custom'
    ]),
    // 城市弹框当前是否展开（visible 是 Dropdown 的展开态，
    // showCityList 是「定位失败后强制展开」用的标记）
    cityPanelOpen() {
      return !!(this.visible || this.showCityList);
    },
    // 是否已经选过城市：只有选过才允许点弹框外面关闭弹框
    hasChoosedCity() {
      const city = this.currentCity || {};
      // id === -1 是各页面约定的「还没选过城市」标记
      if (+city.id === -1) return false;
      if (city.nm) return true;
      // currentCity 还没同步过来时的兜底：看本地存的定位城市
      const stored = localStorage.get('lastLocationCityInfo');
      return !!(stored && stored.nm && +stored.id !== -1);
    }
  },
  watch: {
    $route: {
      handler() {
        this.searchWords = this.$route.query.keyword;
        this.checkPath();
        this.setAlone();
      },
      immediate: true
    },
    alone_custom() {
      this.setAlone();
    },
    currentCity: {
      handler(val) {
        // id 为 -1 是「还没选过城市」的约定标记（首页/电影/旅游/生日等页面请求失败时
        // 会把城市置成它）。这里不再直接弹 toast、也不再抢先展开浮层：
        //   1）抢在「定位失败」提示之前展开，提示弹窗会盖在城市浮层上，两个提示叠在一起；
        //   2）「请先选择城市」与后端返回的「city_id 不能为空」说的是同一件事，属重复提示。
        // 统一由定位结果引导：失败 → 温馨提示（去选择城市）→ 展开浮层；
        // 定位已给出结论、城市仍为空时，才由这里兜底展开。
        if (!val || val.id != -1) return;
        if (this.cityGuideSettled) return this.openCityPanel();
        // 兜底：定位流程迟迟没有结论（城市列表接口异常等）时也不能把用户卡死，
        // 城市浮层是唯一能自救的入口
        clearTimeout(this.cityGuideTimer);
        this.cityGuideTimer = setTimeout(() => {
          if (!this.cityGuideSettled) this.openCityPanel();
        }, 3000);
      },
      immediate: true
    }
  }
};
</script>

<style lang="scss" scoped>
.header {
  width: 100%;
  height: 100%;
  min-width: 960px;
  position: relative;
  height: $app-header-height;
  // 城市弹框蒙版：半透明黑，压住页面内容与头部，让下拉面板（z-index:900）保持最亮。
  // 层级必须低于 900，否则会盖住城市列表；也不需要挡住面板的点击
  .cityMask {
    position: fixed;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    z-index: 850;
    background: rgba(0, 0, 0, 0.3);
  }
  .notice {
    background: #fffce6;
    height: 30px;
    &-content {
      width: 1150px;
      margin: auto;
    }
  }
  &-content {
    width: 1150px;
    margin: 0 auto;
    padding: 30px 0;
  }
  &-logo {
    height: 60px;
    cursor: pointer;
  }
  .headRight {
    border-left: 1px solid #dddddd;
    margin-left: 20px;
    padding-left: 25px;
    .tag {
      color: #333333;
      font-size: 16px;
      font-weight: bold;
    }
    .choseCity {
      font-weight: bold;
      /deep/ a {
        @include color_primary($color-primary);
      }
      /* 城市面板：iView 给下拉容器（padding: 5px 0）和 item（padding: 7px 16px）都带内边距，
         会让里面的滚动区到不了面板上下边缘 —— 表现为鼠标划过时面板「头部与底部有白条」。
         与同文件 .search-wrap 的处理保持一致，去掉内边距并裁到圆角内 */
      /deep/ .ivu-select-dropdown,
      /deep/ .ivu-dropdown-item {
        padding: 0;
      }
      /deep/ .ivu-select-dropdown {
        overflow: hidden;
        border-radius: 4px;
      }
    }
    .showCityList {
      /deep/ .ivu-select-dropdown {
        display: block !important;
      }
    }
  }
  .search-input {
    width: 450px;
    height: 44px;
    margin-left: 20px;
    /deep/ input {
      width: 380px;
      height: 44px;
      font-size: 14px;
      @include border_color($border-color);
      border-radius: 25px;
      padding-left: 20px;
      transform: translateX(20px);
    }
    /deep/ i {
      font-size: 24px;
    }
  }
  .search-wrap {
    /deep/ .ivu-dropdown-item,
    /deep/ .ivu-select-dropdown {
      padding: 0;
    }
    /deep/ .ivu-input-group-append {
      width: 80px !important;
      border-radius: 25px;
    }
  }
  .MenuBox {
    background: #f1f1f1;
    .HeaderMenu {
      margin: auto;
    }
  }
  .channelBox {
    @include background_primary($background-color);
    height: 44px;
    .content {
      height: 100%;
      width: 1150px;
      margin: auto;
      position: relative;
      overflow: unset;
    }
  }
}
</style>
